import * as React from 'react';

import a11yKeyPress from 'js/lib/a11yKeyPress';

import type { CmlContent } from 'bundles/cml';

import 'css!./__styles__/LikeContent';

type Props = {
  selected: boolean;
  onDeselect: () => void;
  onSelect: (comment: CmlContent) => void;
  comment: CmlContent;
  children: React.ReactNode;
};

const LikeContent: React.FC<Props> = ({ selected, onSelect, onDeselect, children, comment }) => {
  const handleClick = () => {
    if (selected) {
      onDeselect();
    } else {
      onSelect(comment);
    }
  };

  return (
    <div className="rc-LikeContent">
      {/* The <div> element has a child <button> element that allows keyboard interaction */}
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={handleClick} onKeyPress={(event) => a11yKeyPress(event, handleClick)}>
        {children}
      </div>
    </div>
  );
};

export default LikeContent;
